module.exports = "../images/dock.jpg?v=bec6867";